import { render, staticRenderFns } from "./RevenueAccountBox.vue?vue&type=template&id=fc27c1c6&scoped=true&"
import script from "./RevenueAccountBox.vue?vue&type=script&lang=js&"
export * from "./RevenueAccountBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc27c1c6",
  null
  
)

export default component.exports